module.exports = __webpack_public_path__ + "img/section3.f58f416c.png";